import { FAIcon } from '@/components'
import { cn } from '@/lib/utils'
import type { LocalStorageSettingPath } from '@/utils'
import { useLocalStorageSetting } from '@/utils'
import type { FontAwesomeIcon } from '@ur-solutions/react-components'
import { type PropsWithChildren } from 'react'

interface Props extends PropsWithChildren {
  className?: string

  type: 'files' | 'comments' | 'logs'
  title: string
  icon: FontAwesomeIcon
}

export function AbsenceDetailsCard({
  children,
  className,

  type,
  title,
  icon,
}: Props) {
  const path = (() => {
    switch (type) {
      case 'comments':
        return 'absenceCardCollapsed.comments'
      case 'files':
        return 'absenceCardCollapsed.files'
      case 'logs':
        return 'absenceCardCollapsed.logs'
    }
  })() satisfies LocalStorageSettingPath

  const [collapsed, updateCollapsed] = useLocalStorageSetting(path)

  return (
    <section
      className={cn(
        'overflow-hidden rounded-2xl bg-white shadow-card',
        className
      )}
    >
      <header
        className="flex items-center justify-between border-b border-stone-200 px-5 py-4 sm:px-6 select-none"
        role="button"
        aria-expanded={!collapsed}
        onClick={() => updateCollapsed(v => !v)}
      >
        <div className="flex items-center gap-2">
          <FAIcon
            className="text-stone-500"
            icon={icon}
            type="regular"
            fixedWidth
          />

          <h3 className="text-lg font-semibold text-stone-900">{title}</h3>
        </div>

        <FAIcon
          className={cn(
            'text-stone-500 hover:text-stone-700 transition-transform',
            !collapsed && 'rotate-180'
          )}
          role="button"
          icon="chevron-down"
        />
      </header>

      {!collapsed && children}
    </section>
  )
}
